<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="d-block">
          <div class="section-title">Seat Quotas</div>
          <div class="section-subTitle my-2">
            List of all Seat Quotas
          </div>
        </div>
        <!-- <div>
          <b-form-input
            v-debounce:300="onSearchAgents"
            v-model="searchValue"
            :placeholder="$tc('searchs')"
          ></b-form-input>
        </div> -->
      </div>

      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="d-flex align-items-center">
          <div class="mx-2">
            <!-- v-if="$can('create', 'Seat Quota Management')" -->
            <b-button
              variant="default"
              to="add-seat-quota-management"
              class="btn-blue"
              >{{ $tc("add") }}</b-button
            >
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left" style="width: 145px;">
              <span class="">{{ $tc("status", 2) }}</span>
            </th>
            <th class="text-left">Setting</th>
            <th class="text-left">Description</th>
            <th class="text-right">Overall Percentage</th>
            <th class="text-right"></th>
          </tr>
        </thead>
        <tbody v-if="quotaSettings && quotaSettings.length > 0">
          <tr
            v-for="(setting, settingIndex) in quotaSettings"
            :key="settingIndex"
            class="light_grey_back"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    setting.qs_is_active == 'Y'
                      ? 'active'
                      : setting.qs_is_active == 'N' && 'inactive'
                  "
                />
                <span
                  @click="onEditSeatQuota(setting)"
                  class="edit-icon ml-2 cursor-pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <span class="edit-pen blue-icon"></span>
                </span>
              </div>
            </td>
            <td class="text-left">
              {{ setting.qs_name || "-" }}
            </td>
            <td class="text-left">
              {{ setting.qs_description || "-" }}
            </td>
            <td class="text-right">
              {{
                parseFloat(setting["overall_quota_percentage"] || 0).toFixed(3)
              }}
            </td>
            <td class="text-right">
              <span
                v-if="setting.is_default == 'Y'"
                class="border rounded px-2 py-1 c-pointer font-small-caps"
              >
                default
              </span>
              <span
                v-else
                class="border rounded px-2 py-1 c-pointer font-small-caps"
                @click="onUpdateDefault(setting)"
              >
                Set Default
              </span>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="4">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="quotaSettings.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import CinemaService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import moment from "moment";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      agentInfo: {
        agent_id: null,
        name: "Guest",
        current_balance: 0,
        overdraft_limit: 0,
        amount: 0,
        remarks: ""
      },
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      quotaSettings: [],

      gridView: false,
      listView: true,

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  mounted() {
    this.getAllQuotaSettings();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }
      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    }
  },

  methods: {
    moment,
    onUpdateDefault(setting) {
      let loader = this.$loading.show();

      let payload = {
        quota_setting_id: setting["quota_setting_id"]
      };

      CinemaService.UpdateDefaultQuotaSettings(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.$toasted.show(data.message);
            this.getAllQuotaSettings();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Erorr:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onEditSeatQuota(setting) {
      this.$router.push({
        name: "Update Seat Quota",
        params: { quota_setting_id: setting["quota_setting_id"] }
      });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAllQuotaSettings();
      } else {
        this.currentPage = event;
        this.getAllQuotaSettings();
      }
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getAllQuotaSettings();
    },
    getAllQuotaSettings: function(filterIsActive = "Y") {
      this.quotaSettings = [];
      let loader = this.$loading.show();
      let payload = {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter_is_active: filterIsActive
      };
      CinemaService.GetAllQuotaSettings(payload)
        .then(response => {
          const { data } = response;

          if (
            data.status &&
            data.Records &&
            data.Records.hasOwnProperty("data") &&
            data.Records.data.length > 0
          ) {
            this.quotaSettings = data.Records.data;
            if (data.Records.pagination.hasOwnProperty("total")) {
              if (data.Records.pagination.total >= 10) {
                this.rows = data.Records.pagination.total;
              } else {
                this.rows = data.Records.pagination.total;
                this.selectedvalue = data.Records.pagination.total;
              }
            }
          } else {
            this.$toasted.show(data.message || "Something Went Wrong!");
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>
<style>
.currCodeClass {
  font-size: 10px;
}

.default-card {
  border: 1px solid lightgrey;
  padding: 2px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SeatQuotaManagement/ListSeatQuotas.vue